function localiteController($localStorage, $state, $scope, WS, $window) {
    'ngInject';
    const vm = this;
    vm.localites = {};
    vm.files = [];
    vm.searchbox = '';
    vm.get = function(page=1) {
      var url = 'localites?page='+page;
        if(vm.searchbox != ''){
           url +='&search='+vm.searchbox;
        }
        WS.get(url)
            .then(function(response) {
                if (response.status == 200) {
                    vm.localites = response.data.data;
                    vm.current_page = response.data.current_page;
                    vm.next = vm.current_page + 1;
                    vm.from     = response.data.form;
                    vm.last_page = Number(response.data.last_page);
                    vm.next_page_url = response.data.next_page_url;
                    vm.per_page = Number(response.data.per_page);
                    vm.prev_page_url = response.data.prev_page_url;
                    vm.to = response.data.to;
                    vm.total = response.data.total;
                    vm.paginate = [];
                    for(var i=1; i <= vm.last_page; i++){
                       vm.paginate.push(i);
                     }
                     $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    }

    vm.update = function(localite) {
          console.log(localite);
        WS.put('localites/' + localite.id, localite)
            .then(function(response) {
                if (response.status == 200) {
                    //vm.getOnelocalite(localite.id);
                    swal(
                      'Succès',
                      'localite modifiée avec Succès',
                      'success'
                    ).then(function(){
                        $window.location.reload();
                    });
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    }


    vm.delete = function(id){
          swal({
              title: 'Supprimer',
              text: "Voullez vous vraiment supprimer ce locale!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Oui',
              cancelButtonText: 'Non',
              confirmButtonClass: 'btn btn-success',
              cancelButtonClass: 'btn btn-danger',
              buttonsStyling: false
          }).then(function () {
              WS.delete('localites/' + id).then(
                  function(){
                      swal(
                              'Supprimée!',
                              'locale Supprimée.',
                              'success'
                      ).then(function(){
                          $window.location.reload();
                      });
                  },
                  function(){
                      swal(
                          'Attention!',
                          'Vous ne pouvez pas supprimer ce locale',
                          'warning'
                      );
                  }
              );
          });
    };
    vm.ajouter = function(localite) {
        WS.post('localites', localite)
            .then(function(response) {
                if (response.data.success == true) {
                    swal(
                      'Succès',
                      'localite ajoutée avec Succès',
                      'success'
                    ).then(function(){
                        $window.location.reload();
                    });
                    
                } else if(response.data.success == false) {
                    swal('Error', response.data.message,'error');
                }
            })
            .then(null, function(error) {
                console.log(error);
            });
    }

    vm.getDelegations = function() {
        WS.get('delegations', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    vm.delegations = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };


    vm.selectDelegations = function() {
        WS.get('delegations/selectDelegations')
            .then(function(response) {
                if (response.status == 200) {
                    vm.delegations = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };
    vm.getGouvernerats = function() {
        WS.get('gouvernorats', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    vm.gouvernorats = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    }
    vm.getRegions = function() {
        WS.get('regions', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    vm.regions = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    $scope.moveCSV = function(element) {
        var reader = new FileReader();
            reader.onload = function(event) {
              vm.csvfile.file = event.target.result;
              $scope.$apply(function() {
                vm.files = element.files;
              });
            }
        reader.readAsDataURL(element.files[0]);
    };

    vm.savecsv = function(){
        vm.csvfile.file = vm.files[0];
        WS.postwithimg('localites/saveCsv' , vm.csvfile , "POST")
            .then(function(response){
                if (response.data.success==true) {
                    vm.traitform=false;
                    vm.csvfile={}
                    $scope.$apply();
                    swal(
                      'Succée',
                      response.data.message,
                      'success'
                    ).then(function(){
                      WS.getScache('localites')
                          .then(function(response) {
                              if (response.status == 200) {
                                  vm.localites = response.data;
                                  $scope.$apply();
                              } else {}
                          })
                          .then(null, function(error) {
                              console.log(error);
                          });
                    });  
                } else {
                    vm.traitform=false;
                    vm.csvfile={}
                    $scope.$apply();
                    swal(
                      'Warning',
                      response.data.message,
                      'warning'
                    ); 
                }
           },function(error){
                console.log(error);
           });
    };

    vm.downloadCsvModel = function(){
        var filename = 'localite';
        alasql('SELECT * INTO XLS("'+ filename +'.xls",?) FROM ?',[csvModel, []]); 
    };

    var csvModel = {
              sheetid: 'localite',
              headers: true,
              column: {
                  style:'font-size:20px;background:#d1d1d1;'
              },
              columns: [
                  {columnid:'code', title: 'Code'},
                  {columnid:'libelle',title: 'Libelle'},
                  {columnid:'cp', title: 'cp'},
                  {columnid:'region_code', title: 'region_code'},
                  {columnid:'delegation_code', title: 'delegation_code'},
                  {columnid:'gouvernorat_code', title: 'gouvernorat_code'},
              ],
              rows: {
                  style: function(sheet,row,rowidx){
                      return 'text-align:center;background:'+(rowidx%2?'#fff':'#f1f1f1')+';height:100px!important;';
                  }
              }
    };
}
export default {
    name: 'localiteController',
    fn: localiteController
};
